// Merge properties that have been automatically calculated, and properties that have been manually inputted
export const getMergedSettings = (defaultSettings, settingsToMerge) => {
  const calculatedSettings = defaultSettings
    ? Object.fromEntries(Object.entries(defaultSettings))
    : {};

  const incomingSettings = settingsToMerge
    ? Object.fromEntries(
        Object.entries(settingsToMerge).filter(([, value]) => value !== undefined)
      )
    : {};

  return {
    ...calculatedSettings,
    ...incomingSettings
  };
};
